import { getUserError } from '../components/miscUtils';
import { TpDataContext } from './interfaces';

export function validateDataContext(dataContext: TpDataContext) {
  const issues: string[] = [];
  for (const dataTable of dataContext.dataTables) {
    //verify that if a column is assigned to a group, that group exists
    const groupMap = Object.fromEntries(dataTable.columnGroups.map((group) => [group.id, true]));
    for (const column of dataTable.columns)
      if (column.groupId && !groupMap[column.groupId]) {
        //        issues.push(`Invalid group id for ${dataTable.id}.${column.id}: ${column.groupId}`); Temporary removed to accomodate for BioMx data @todo: re-instate
      }
  }

  if (issues.length > 0) throw getUserError(issues.join('\n'));
}
